__turbopack_context__.v({
  "breadcrumbs": "HoB1Ja_breadcrumbs",
  "crumb": "HoB1Ja_crumb",
  "current-page": "HoB1Ja_current-page",
  "link": "HoB1Ja_link",
});
